var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTopStars(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 119,
    viewBox: "0 0 119 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.8754 57.5098C36.0241 59.4594 40.5167 60.5715 45.0955 60.7824C49.6743 60.9933 54.2494 60.2988 58.5586 58.7388C62.8678 57.1788 66.8263 54.7839 70.2073 51.6914C73.5883 48.5989 76.3254 44.8695 78.2616 40.717L78.3238 40.5844C70.098 58.1262 77.5714 78.9377 95.0151 87.1174L31.8754 57.5098Z",
    fill: "#E9C0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8749 57.51C36.0261 59.4532 39.7533 62.1958 42.8431 65.5808C45.9328 68.9658 48.3244 72.9266 49.8809 77.2365C51.4374 81.5463 52.1281 86.1204 51.9135 90.6969C51.6989 95.2733 50.5832 99.7621 48.6304 103.906L48.5702 104.034C56.7859 86.5141 77.5749 78.9294 95.0186 87.1091L31.8749 57.51Z",
    fill: "#E9C0FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7535 17.811C32.0824 18.9054 34.6043 19.5296 37.1745 19.648C39.7448 19.7664 42.313 19.3766 44.7319 18.5009C47.1509 17.6252 49.3729 16.2808 51.2708 14.5449C53.1687 12.8089 54.7052 10.7155 55.792 8.38451L55.8269 8.31006C51.2095 18.157 55.4046 29.8393 65.1965 34.431L29.7535 17.811Z",
    fill: "#E9C0FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7536 17.8118C32.0838 18.9025 34.1761 20.4421 35.9105 22.3422C37.6449 24.2423 38.9874 26.4657 39.8611 28.885C40.7348 31.3043 41.1226 33.872 41.0021 36.4409C40.8817 39.0098 40.2554 41.5296 39.1592 43.8558L39.1254 43.9279C43.7372 34.0929 55.4069 29.8353 65.1988 34.4269L29.7536 17.8118Z",
    fill: "#E9C0FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopStars);
export default __webpack_public_path__ + "static/media/topStars.c6f126c4.svg";
export { ForwardRef as ReactComponent };